var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview"},[_c('div',{staticClass:"icon"},[_c('i',{class:'af-icons-md af-icons-md-circle-' + _vm.icon}),_c('br'),_vm._v(" "),_c('span',{staticClass:"attachment-type"},[_vm._v("\n      "+_vm._s(_vm.extension.toUpperCase())+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }